export default __webpack_public_path__ + "static/media/table-sorted-desc.45338b29.svg";